const {
  pavelSaskovec,
  mariaTarnopalskaya,
  anastasiyaVishnevskaya,
  kseniyaMeshkova,
} = require('./experts');

module.exports = [
  {
    url: '/blog/top-video-subtitle-generators/',
    img: '/uploads/resources/blog/top-video-subtitle-generators/0.jpg',
    date: 'Oct 12, 2023',
    title: '10 best video subtitle generators for your social media strategy',
    author: pavelSaskovec,
    readTime: 15,
  },
  {
    url: '/blog/3-reasons-not-to-get-on-an-ai-generated-content-train/',
    img: '/uploads/resources/blog/3-reasons-not-to-get-on-an-ai-generated-content-train/0.jpg',
    date: 'May 17, 2023',
    title: '3 reasons not to get on an AI-generated content train',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/how-ai-automation-can-streamline-video-advertising/',
    img: '/uploads/resources/blog/how-ai-automation-can-streamline-video-advertising/0.jpg',
    date: 'April 06, 2023',
    title: '3 ways how AI automation can streamline video advertising',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/we-made-a-powerful-visual-ai-video-editing-web-app-klipme/',
    img: '/uploads/resources/blog/we-made-a-powerful-visual-ai-video-editing-web-app-klipme/0.jpg',
    date: 'March 21, 2023',
    title:
      'We made a powerful Visual AI video editing web app — Klipme — to solve your video editing problems',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/can-ai-tools-like-chatgpt-replace-humans-in-media-industry/',
    img: '/uploads/resources/blog/can-ai-tools-like-chatgpt-replace-humans-in-media-industry/0.jpg',
    date: 'February 28, 2023',
    title:
      'Can AI tools like ChatGPT replace humans in the media industry? Let the AI company tell you',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/what-streaming-platforms-have-in-store-for-us-in-2023/',
    img: '/uploads/resources/blog/what-streaming-platforms-have-in-store-for-us-in-2023/0.jpg',
    date: 'February 01, 2023',
    title: 'What streaming platforms have in store for us in 2023',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/chatGPT-is-gaining-traction/',
    img: '/uploads/resources/blog/chatGPT-is-gaining-traction/0.jpg',
    date: 'January 20, 2022',
    title:
      'ChatGPT is gaining traction. Here is how media companies can get in on it',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/ai-video-switcher/',
    img: '/uploads/resources/blog/ai-video-switcher/0.jpg',
    date: 'December 29, 2022',
    title: 'Improve your sports live streaming with AI video switcher',
    author: pavelSaskovec,
    readTime: 6,
  },
  {
    url: '/blog/ad-insertion-in-live-streams/',
    img: '/uploads/resources/blog/ad-insertion-in-live-streams/0.jpg',
    date: 'December 16, 2022',
    title: 'Automating ad insertion in live streams with Cognitive Computing',
    author: pavelSaskovec,
    readTime: 5,
  },
  {
    url: '/blog/video-marketing-challenges/',
    img: '/uploads/resources/blog/video-marketing-challenges/0.jpg',
    date: 'November 22, 2022',
    title:
      'How automation can help you overcome major challenges in video marketing',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/future-of-ai/',
    img: '/uploads/resources/blog/future-of-ai/2.jpg',
    date: 'November 11, 2022',
    title:
      'The future of AI for media and entertainment: the decision-making factor',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/video-text-to-speech/',
    img: '/uploads/resources/blog/video-text-to-speech/3.jpg',
    date: 'October 27, 2022',
    title: 'How to use video speech to text for media automation the right way',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/ai-in-video-advertising/',
    img: '/uploads/resources/blog/ai-in-video-advertising/1.jpg',
    date: 'October 12, 2022',
    title: 'The benefits of implementing AI in video advertising',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/aihunters-first-ibc/',
    img: '/uploads/resources/blog/aihunters-first-ibc/2.jpg',
    date: 'September 28, 2022',
    title: 'AIHunters’ first IBC: a little startup in a big world',
    author: anastasiyaVishnevskaya,
    readTime: 6,
  },
  {
    url: '/blog/metaverse-in-media-and-entertainment-2022/',
    img: '/uploads/resources/blog/metaverse-in-media-and-entertainment-2022/2.jpg',
    date: 'September 23, 2022',
    title:
      'Emergence of the metaverse in media and entertainment: trends and use cases for 2022',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/media-industry-technology-trends-2023/',
    img: '/uploads/resources/blog/media-industry-technology-trends-2023/5.jpg',
    date: 'September 16, 2022',
    title: 'Technology trends in the media industry to keep track of for 2023',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/how-transform-media-business-with-ai-automation/',
    img: '/uploads/resources/blog/how-transform-media-business-with-ai-automation/2.jpg',
    date: 'November 22, 2022',
    title: 'How to transform your media business with AI automation',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/sentiment-analysis/',
    img: '/uploads/resources/blog/sentiment-analysis/1.jpg',
    date: 'November 29, 2022',
    title: 'Catching feelings: sentiment analysis in video content',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/creating-the-cognitive-mill-platform-architecture/',
    img: '/uploads/resources/blog/creating-the-cognitive-mill-platform-architecture/02.jpg',
    date: 'August 31, 2022',
    title: 'Creating the Cognitive Mill platform architecture',
    author: mariaTarnopalskaya,
    readTime: 5,
  },
  {
    url: '/blog/what-is-cognitive-computing/',
    img: '/uploads/resources/blog/what-is-cognitive-computing/1.jpg',
    date: 'August 19, 2022',
    title: 'What is Cognitive Computing?',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/evolving-mediamill-into-a-flexible-media-generation-and-editing-product/',
    img: '/uploads/resources/blog/evolving-mediamill-into-a-flexible-media-generation-and-editing-product/01.png',
    date: 'August 12, 2022',
    title:
      'Evolving Cognitive Mill&trade; into a flexible media generation and editing product',
    author: mariaTarnopalskaya,
    readTime: 11,
  },
  {
    url: '/blog/pros-and-cons-of-ai/',
    img: '/uploads/resources/blog/pros-and-cons-of-ai/5.jpg',
    date: 'August 01, 2022',
    title: 'Pros and cons of Artificial Intelligence',
    author: pavelSaskovec,
    readTime: 6,
  },
  {
    url: '/blog/ai-in-gaming/',
    img: '/uploads/resources/blog/ai-in-gaming/1.jpg',
    date: 'July 20, 2022',
    title: 'AI in gaming: become (better than) human',
    author: pavelSaskovec,
    readTime: 10,
  },
  {
    url: '/blog/how-we-perceive-visual-complexity-and-how-its-analysis-helps-solve-business-tasks/',
    img: '/uploads/resources/blog/how-we-perceive-visual-complexity-and-how-its-analysis-helps-solve-business-tasks/01.jpg',
    date: 'July 19, 2022',
    title:
      'How we perceive visual complexity and how its analysis helps solve business tasks',
    author: mariaTarnopalskaya,
    readTime: 9,
  },
  {
    url: '/blog/cognitive-ai/',
    img: '/uploads/resources/blog/cognitive-ai/0.jpg',
    date: 'July 12, 2022',
    title: 'Cognitive Artificial Intelligence: it’s free decision-making',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/video-summarization/',
    img: '/uploads/resources/blog/video-summarization/2.jpg',
    date: 'June 21, 2022',
    title:
      'Summarize your long-form content with automated video cutting software',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/sports-highlights-video-maker/',
    img: '/uploads/resources/blog/sports-highlights-video-maker/2.jpg',
    date: 'May 25, 2022',
    title:
      'Alright, enough with those “Top 5” articles: we got the best sports highlight video maker right here',
    author: pavelSaskovec,
    readTime: 11,
  },
  {
    url: '/blog/imitating-human-attention/',
    img: '/uploads/resources/blog/imitating-human-attention/8.jpg',
    date: 'May 24, 2022',
    title: 'Imitating human attention',
    author: mariaTarnopalskaya,
    readTime: 12,
  },
  {
    url: '/blog/video-content-management/',
    img: '/uploads/resources/blog/video-content-management/5.jpg',
    date: 'May 12, 2022',
    title:
      'Please stop losing your clips: effective video content management with cognitive computing',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/why-deep-learning-is-not-enough-for-video-analysis-automation/',
    img: '/uploads/resources/blog/why-deep-learning-is-not-enough-for-video-analysis-automation/12.jpg',
    date: 'Apr 15, 2022',
    title: 'Why deep learning is not enough for video analysis automation',
    author: mariaTarnopalskaya,
    readTime: 10,
  },
  {
    url: '/blog/netflix-ai-to-optimize-content-production/',
    img: '/uploads/resources/blog/netflix-ai-to-optimize-content-production/2.jpg',
    date: 'Apr 14, 2022',
    title:
      'Hey Netflix, here&rsquo;s how you can use AI to optimize content production',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/cognitive-mill-on-the-way-to-cognitive-audio-visual-analysis/',
    img: '/uploads/resources/blog/cognitive-mill-on-the-way-to-cognitive-audio-visual-analysis/03.png',
    date: 'Mar 30, 2022',
    title: 'Cognitive Mill on the way to full cognitive audio-visual analysis',
    author: mariaTarnopalskaya,
    readTime: 9,
  },
  {
    url: '/blog/automated-video-game-highlights/',
    img: '/uploads/resources/blog/automated-video-game-highlights/4.jpg',
    date: 'Mar 29, 2022',
    title:
      'Boost the views on your eSports events with automated video game highlights',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/human-augmentation-media-entertainment/',
    img: '/uploads/resources/blog/human-augmentation-media-entertainment/6.jpg',
    date: 'Mar 28, 2022',
    title: 'Human augmentation in media and entertainment',
    author: pavelSaskovec,
    readTime: 11,
  },
  {
    url: '/blog/top-5-ai-video-analytics-companies/',
    img: '/uploads/resources/blog/top-5-ai-video-analytics-companies/1.jpg',
    date: 'Feb 25, 2022',
    title: 'Top 5 AI video analytics companies',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/nvidia-triton-inference-server-for-cognitive-video-analysis/',
    img: '/uploads/resources/blog/nvidia-triton-inference-server-for-cognitive-video-analysis/1.png',
    date: 'Feb 22, 2022',
    title: 'NVIDIA Triton Inference Server for cognitive video analysis',
    author: mariaTarnopalskaya,
    readTime: 7,
  },
  {
    url: '/blog/celebrity-face-recognition-make-streaming-just-a-little-bit-better/',
    img: '/uploads/resources/blog/celebrity-face-recognition-make-streaming-just-a-little-bit-better/2.jpg',
    date: 'Feb 11, 2022',
    title:
      'Celebrity face recognition: make streaming just a little bit better',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/here-how-ai-generated-movie-trailers-spare-the-editors-time/',
    img: '/uploads/resources/blog/here-how-ai-generated-movie-trailers-spare-the-editors-time/3.jpg',
    date: 'Jan 21, 2022',
    title:
      'Here&rsquo;s how AI-generated movie trailers spare the editors&rsquo; time',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/cognitive-computing-for-the-media-and-entertainment-industry-automation/',
    img: '/uploads/resources/blog/cognitive-computing-for-the-media-and-entertainment-industry-automation/1.jpg',
    date: 'Jan 06, 2022',
    title:
      'Cognitive computing for the media & entertainment industry automation',
    author: mariaTarnopalskaya,
    readTime: 9,
  },
  {
    url: '/blog/seamless-viewing-experience-with-native-video-ads/',
    img: '/uploads/resources/blog/seamless-viewing-experience-with-native-video-ad/1.jpg',
    date: 'Jan 05, 2022',
    title: 'Seamless viewing experience with native video ads',
    author: pavelSaskovec,
    readTime: 7,
  },
  {
    url: '/blog/how-to-enhance-user-engagement-with-cognitive-computing/',
    img: '/uploads/resources/blog/how-to-enhance-user-engagement-with-cognitive-computing/2.png',
    date: 'Dec 10, 2021',
    title: 'How to enhance user engagement with cognitive computing',
    author: pavelSaskovec,
    readTime: 9,
  },
  {
    url: '/blog/fixing-problems-with-making-sports-highlights-reels/',
    img: '/uploads/resources/blog/fixing-problems-with-making-sports-highlights-reels/1.jpg',
    date: 'Nov 26, 2021',
    title:
      'Cognitive Mill&trade;: fixing problems with making sports highlights reels',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/why-your-streaming-platform-needs-automated-nudity-filtering/',
    img: '/uploads/resources/blog/why-your-streaming-platform-needs-automated-nudity-filtering/1.jpg',
    date: 'Nov 12, 2021',
    title: 'Why your streaming platform needs automated nudity filtering',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/automated-video-cropping-tool/',
    img: '/uploads/resources/blog/automated-video-cropping-tool/nba-mobile-video-content.jpg',
    date: 'Nov 03, 2021',
    title: 'Automated video cropping tool to boost your social media',
    author: pavelSaskovec,
    readTime: 8,
  },
  {
    url: '/blog/final-italy-england/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 21, 2021',
    title:
      'Italy vs Englang video highlights - Final - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/semi-finals-england-denmark/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 07, 2021',
    title:
      'England vs Denmark video highlights - Semi Finals - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/semi-finals-italy-spain/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 06, 2021',
    title:
      'Italy vs Spain video highlights - Semi Finals - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/quarter-finals-ukraine-england/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 03, 2021',
    title:
      'Ukraine vs England video highlights - Quarter Finals - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/quarter-finals-belgium-italy/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 02, 2021',
    title:
      'Belgium vs Italy video highlights - Quarter Finals - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/quarter-finals-switzerland-spain/',
    img: '/uploads/resources/blog/euro-2020-highlight-reels/card.jpg',
    date: 'Jul 02, 2021',
    title:
      'Switzerland vs Spain video highlights - Quarter Finals - Euro 2020',
    author: anastasiyaVishnevskaya,
    readTime: 1,
  },
  {
    url: '/blog/end-credits-detection-cognitive-mill-vs-aws-rekognition/',
    img: '/uploads/resources/blog/end-credits-detection-cognitive-mill-vs-aws-rekognition/1.jpg',
    date: 'Apr 08, 2021',
    title: 'Cognitive Mill vs. AWS media intelligence: test run',
    author: anastasiyaVishnevskaya,
    readTime: 12,
  },
  {
    url: '/blog/ai-based-end-credits-detection/',
    img: '/uploads/resources/blog/ai-based-end-credits-detection/1.jpg',
    date: 'Mar 25, 2021',
    title:
      'AI-based end credits detection automation to boost viewer engagement',
    author: anastasiyaVishnevskaya,
    readTime: 10,
  },
  {
    url: '/blog/how-i-met-aihunters/',
    img: '/uploads/resources/blog/how-i-met-aihunters/1.jpg',
    date: 'Jan 27, 2021',
    title: 'How I met AIHunters',
    author: mariaTarnopalskaya,
    readTime: 10,
  },
  {
    url: '/blog/horse-racing-tracking/',
    img: '/uploads/resources/blog/horse-racing-tracking/card.jpg',
    date: 'Jan 21, 2021',
    title: 'Horse racing tracking',
    author: kseniyaMeshkova,
    readTime: 7,
  },
  {
    url: '/blog/football-and-basketball-highlights-generation/',
    img: '/uploads/resources/blog/football-and-basketball-highlights-generation/1.jpg',
    date: 'Jan 11, 2021',
    title: 'Football and basketball highlights generation',
    author: anastasiyaVishnevskaya,
    readTime: 6,
  },
  {
    url: '/blog/how-we-track-identical-objects-with-the-probabilistic-data-association-approach/',
    img: '/uploads/resources/blog/how-we-track-identical-objects-with-the-probabilistic-data-association-approach/card.jpg',
    date: 'Sep 23, 2020',
    title:
      'How we track identical objects with the probabilistic data association approach',
    author: anastasiyaVishnevskaya,
    readTime: 6,
  },
];
